import { GBP } from "./Listing";
 import { LocationApi, AccountCard } from "../hooks/useGBPListingManagement";

export const mapLocationToGBP = (
  loc: LocationApi,
  normalizeHost: (url?: string | null) => string,
  selectedAccount?: AccountCard | null,
   fallbackAccountId?: string
): GBP => {

  const a = loc.storefrontAddress || {};

  const accountFromLocName = loc.name?.match(/^(accounts\/[^/]+)\//)?.[1];

  const resolvedAccountName =
    accountFromLocName ||
    selectedAccount?.resourceName ||
    selectedAccount?.name ||
    (fallbackAccountId
      ? `accounts/${fallbackAccountId.replace(/^accounts\//, "")}`
      : undefined);

  const fullLocationId = accountFromLocName
    ? loc.name
    : resolvedAccountName && loc.name
    ? `${resolvedAccountName}/${loc.name}`
    : loc.name;

  return {
    id: 0,
    name: loc.title || "",
    category: loc.categories?.primaryCategory?.displayName || "",
    primaryCategory: loc.categories?.primaryCategory
      ? {
          name:        loc.categories.primaryCategory.name        ?? "",
          displayName: loc.categories.primaryCategory.displayName ?? "",
        }
      : undefined,
    phone:      loc.phoneNumbers?.primaryPhone || "",
    url:        loc.websiteUri || "",
     mapsUri: loc.mapsUri || loc.metadata?.mapsUri || null,

     additionalPhones: loc.phoneNumbers?.additionalPhones || [],

     openStatus: loc.openInfo?.status || null,

     openingDate: loc.openInfo?.openingDate
      ? {
          year: loc.openInfo.openingDate.year ?? 0,
          month: loc.openInfo.openingDate.month ?? 0,
          day: loc.openInfo.openingDate.day ?? 0,
        }
      : undefined,
    locationId: fullLocationId || undefined,
    statut:     "pending",
     accountName: resolvedAccountName,
    address: {
      regionCode:         a.regionCode         || "",
      postalCode:         a.postalCode         || "",
      locality:           a.locality           || "",
      addressLines:       Array.isArray(a.addressLines) ? a.addressLines : [],
      administrativeArea: a.administrativeArea || "",
    },
    
     callClicks: typeof loc.callClicks === "number" ? loc.callClicks : null,  
   status: loc.status, 
  } as GBP;
};